module.exports = __webpack_public_path__ + "static/DNA-Explorer-Personal-white-e9115477e5a11206425a5c977ee9f7f2.png";